<template>
  <div class="contents">
    <base-vue v-if="parentEle.barType !=1 && parentEle.barType != 2 && parentEle.barType != 7 && parentEle.barType != 8"></base-vue>
    <about-us v-else-if="parentEle.barType == 2"></about-us>
    <contact-us v-else-if="parentEle.barType == 7"></contact-us>
    <download v-else-if="parentEle.barType == 8"></download>
    <home-vue v-else @findMoreClick="homeFindMoreClick" @findCompanyInfo="homefindCompanyInfo" @hotProductClick="hotProductClickInfo"></home-vue>
  </div>
</template>
<script>
/* eslint-disable */
import baseVue from '@/components/base.vue';
import homeVue from '@/views/Home.vue';
import aboutUs from '@/views/aboutUs.vue';
import contactUs from '@/views/contact_us.vue'
import download from '@/views/download.vue'
import $ from 'jquery';
export default {
  name: 'contents',
  components: { baseVue, homeVue,contactUs,download,aboutUs },
  props:{
    currentIndex:{
      type:Number,
      default:0
    }
  },
  data() {
    return {

    }
  },
  inject: ['parentEle'],
     mounted() {
       
  },
  methods: {
    //查找更多回调
    homeFindMoreClick(){
       console.log("内容页的查找更多")
       this.$emit('homeFindMoreClick')
    },
    homefindCompanyInfo(){
      //查看公司详情
      console.log("内容页的查找更多")
      this.$emit("homefindCompanyInfo")
    },
    hotProductClickInfo(){
      //热门产品的跳转
      this.$emit("homeHotProductClickInfo")
    }

  }
}
</script>
<style scoped lang="less">
.contents {
  width: 920px;
  //height: calc(~"100% - 540px");
  margin: auto;
}
</style>